module.exports = __webpack_public_path__ + "img/selected2-min.ebe9198d.png";